module.exports = __webpack_public_path__ + "static/media/americanExpress.3215eb83.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/openpay/americanExpress.png
// module id = 173
// module chunks = 0